import React, { Component } from 'react'
import { Col, Row, Container } from 'reactstrap';
import cubeApiClient from '../BusinessObjects/cubeApiService'
import { Redirect } from 'react-router';
import LoggedContext from '../BusinessObjects/LoggedContext'
import { Link } from 'react-router-dom';

export default class Logout extends Component<any,any> {
    static contextType = LoggedContext

    render() {
        var token = this.context.tokenAPI;
    

        if(token > '')
        {      
            this.context.setUserToken('','');
            this.context.setUserProfile(null);
        return(
            <Redirect to="/home"/>);
        }

    }
}
